import type { BulkActionAttr } from './types';

export const UPSERT_FORMAT: BulkActionAttr[] = [
  {
    name: 'code',
    summary: '部署コード',
    example: '123',
    required: true
  },
  {
    name: 'name',
    summary: '部署名',
    example: '営業部',
    required: true
  },
  {
    name: 'postal_code',
    summary: '郵便番号',
    example: '123-4567',
    required: false
  },
  {
    name: 'address',
    summary: '住所',
    example: '東京都○○区1丁目2番3号',
    required: false
  },
  {
    name: 'addressee',
    summary: '宛名',
    example: '◯◯部署宛',
    required: false
  },
  {
    name: 'monthly_budget',
    summary: '月次予算',
    example: '100000',
    required: false
  },
  {
    name: 'disabled',
    summary: '状態',
    example: '無効：1\n有効：0',
    required: false
  }
];
